export default "__VITE_ASSET__Dh5av5Fi__"